import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionFinanceApi = {
    getTrialInstitutionFinanceByTrialInstitutionId: (trialInstitutionId: number): Observable<Dtos.GetTrialInstitutionFinanceByTrialInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionFinanceByTrialInstitutionId = new Dtos.GetTrialInstitutionFinanceByTrialInstitutionId();
        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionFinanceByTrialInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionFinanceById: (id: number): Observable<Dtos.GetTrialInstitutionFinanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionFinanceById = new Dtos.GetTrialInstitutionFinanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionFinanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionFinance: (trialInstitutionFinance: Dtos.TrialInstitutionFinance): Observable<Dtos.SetTrialInstitutionFinanceResponse> => {

        let request: Dtos.SetTrialInstitutionFinance = new Dtos.SetTrialInstitutionFinance();

        request.trialInstitutionFinance = trialInstitutionFinance;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialInstitutionFinance: (trialInstitutionId: number): Observable<Dtos.CreateTrialInstitutionFinanceResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionFinance = new Dtos.CreateTrialInstitutionFinance();

        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionFinanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialInstitutionFinance: (trialInstitutionFinance: Dtos.TrialInstitutionFinance): Observable<Dtos.ValidateTrialInstitutionFinanceResponse> => {

        let request: Dtos.ValidateTrialInstitutionFinance = new Dtos.ValidateTrialInstitutionFinance();

        request.trialInstitutionFinance = trialInstitutionFinance;

        // send request
        const response: Promise<Dtos.ValidateTrialInstitutionFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
}